import { domReady } from './globals';

domReady(() => {

	// ─── INIT ───
	console.log('Solyn Theme Scripts');

	// ─── EVENTS ───

	// ─── UTILITIES ───

	// ─── COMPONENTS ───
});
